import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';
import { greenColor, ResultValueUnit } from './constants';
import { ColouredCost, ColouredCostBig } from '.';
import { ImpactToolLiveResult } from '~/types/impactTool';

export const LiveResultBox: React.FC<{
  result: Pick<
    ImpactToolLiveResult,
    'reduced_car_distance' | 'reduced_co2_emissions'
  >;
}> = ({ result }) => {
  return (
    <Container
      style={{
        margin: '2rem 0 1rem 0',
        padding: '1rem 0',
        borderBottom: '1px solid #ebf7dd',
        maxWidth: 268,
      }}
    >
      <Typography
        variant="h3"
        component="h3"
        style={{
          borderBottom: '1px solid #bec5c9',
          fontWeight: 'normal',
          lineHeight: '32px',
        }}
      >
        Das spart ihre Abstellanlage pro Jahr
      </Typography>

      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="body2" style={{ margin: '1rem 0' }}>
          Pkw-Kilometer:{' '}
        </Typography>
        <ColouredCost
          value={result.reduced_car_distance}
          unit={ResultValueUnit.KM}
          color={greenColor}
        />
      </Box>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          style={{
            fontWeight: 'bold',
            fontSize: 24,
            fontFamily: 'BundesSans',
          }}
        >
          CO<sub>2</sub>-Emissionen:{' '}
        </Typography>
        <ColouredCostBig
          value={result.reduced_co2_emissions}
          unit={ResultValueUnit.TONS}
          component="span"
        />
      </Box>
    </Container>
  );
};
